export const appendQueryParams = (url: string, params: Record<string, string>): string => {
  const separator = url.includes("?") ? "&" : "?";
  const queryString = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  return `${url}${separator}${queryString}`;
};

export const toAbsoluteUrl = (url: string | null | undefined): string => {
  if (!url) {
    return "";
  }
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};

export const getFaviconUrl = (url: string | null | undefined, size = 64): string | null => {
  if (!url) {
    return null;
  }
  const absoluteUrl = toAbsoluteUrl(url);
  if (!URL.canParse(absoluteUrl)) {
    return null;
  }
  const { hostname } = new URL(absoluteUrl);
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(hostname)}&sz=${size}`;
};
